import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ApiService } from '../../api.service';

@Component({
  selector: 'app-saved-orders',
  templateUrl: './saved-orders.component.html',
  styleUrls: ['./saved-orders.component.scss']
})
export class SavedOrdersComponent {
    
  savedOrders:any;

  @Input() customers:any;

  @Output() orderCharged = new EventEmitter();

  constructor(public api:ApiService) { }

  ngOnInit(){
    this.refreshSavedOrders();
  }

  refreshSavedOrders(){
    this.savedOrders = [];
    let ids = this.customers.map(item => item.Id).join("','");
    this.api.post("SPDO=select",{database:'pro_order',where:"CustomerId IN ('"+ids+"') && adminOrder = "+(this.api.adminOrder ? 1 : 0)}).then((res:any)=>{
      if(res && res.data){
        for(let row of res.data){
          try{
            row.order = JSON.parse(row.order_json);
            this.savedOrders.push(row);
          }catch(e){

          }
        }
      }
    });
  }

  delete(row){
    this.api.confirm("Supprimer définitivement la commande sauvegardée ?").then(confirm=>{
      if(confirm == 'ok'){
        this.api.post("SPDO=delete",{database:'pro_order',where:{id_pro_order:row.id_pro_order}}).then((res:any)=>{
          this.refreshSavedOrders();
        });
      }
    });

  }

  chargeOrder(row){
    for(let p of this.api.order.prods){
      p.quantity = 0;
      this.api.changeQty(p);
    }
    setTimeout(()=>{
      if(row.order.prods){
        this.api.order.prods = row.order.prods;
        if(this.api.user)  
          this.api.totalOrder();
        this.orderCharged.emit(row.order);
      }
    },500);
  }
}
